<h1 mat-dialog-title>Textsorte erstellen</h1>
<mat-dialog-content class="w800 custom-scrollbar">
  <app-folder-usage-hint [entryId]="id" type="TEXT_TYPE"></app-folder-usage-hint>

  <mat-vertical-stepper #stepper [linear]="true">
    <!-- Allgemeine Informationen -->
    <mat-step [stepControl]="firstFormGroup" label="Allgemeine Informationen">
      <div class="pad-top8">
        <form [formGroup]="firstFormGroup">
          <div class="row-content">
            <mat-form-field appearance="outline" class="w100">
              <mat-label>Name</mat-label>
              <input formControlName="nameCtrl" matInput placeholder="" required>
            </mat-form-field>
          </div>
        </form>
        <div>
          <button matStepperNext color="primary" mat-raised-button>Weiter</button>
        </div>
      </div>
    </mat-step>

    <!-- Kategorische Informationen -->
    <mat-step [stepControl]="secondFormGroup" label="Themen">
      <div class="pad-top8">
        <form [formGroup]="secondFormGroup">
          <div class="row-content">
            <mat-form-field appearance="outline" class="w49 marg-right2">
              <mat-label>Fertigkeit</mat-label>
              <mat-select formControlName="modesCtrl" multiple>
                @for (option of modesList; track option) {
                  <mat-option [value]="option">{{ this.formOptionsLists.modesToString.get(option) }}</mat-option>
                }
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="w49">
              <mat-label>Bereich</mat-label>
              <mat-select formControlName="domainsCtrl" multiple>
                @for (option of domainsList; track option) {
                  <mat-option [value]="option">{{ this.formOptionsLists.domainsToString.get(option) }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>

          <div class="row-content">
            <mat-form-field appearance="outline" class="w49 marg-right2">
              <mat-label>Interaktion</mat-label>
              <mat-select formControlName="interactionsCtrl" multiple>
                @for (option of interactionsList; track option) {
                  <mat-option [value]="option">{{ this.formOptionsLists.interactionsToString.get(option) }}</mat-option>
                }
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="w49">
              <mat-label>Medium</mat-label>
              <mat-select formControlName="mediaCtrl" multiple>
                @for (option of mediasList; track option) {
                  <mat-option [value]="option">{{ this.formOptionsLists.mediaToString.get(option) }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>

          <div class="row-content">
            <mat-form-field appearance="outline" class="w49 marg-right2">
              <mat-label>Repräsentation</mat-label>
              <mat-select formControlName="representationsCtrl" multiple>
                @for (option of representationsList; track option) {
                  <mat-option [value]="option">{{ this.formOptionsLists.representationsToString.get(option) }}</mat-option>
                }
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="w49">
              <mat-label>Zweck</mat-label>
              <mat-select formControlName="purposeCtrl" multiple>
                @for (option of purposesList; track option) {
                  <mat-option [value]="option">{{ this.formOptionsLists.purposesToString.get(option) }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </form>
        <div style="display: flex; flex-direction: row; gap: 10px;">
          <button mat-raised-button matStepperPrevious>Zurück</button>
          <button color="primary" mat-raised-button matStepperNext>Weiter</button>
        </div>
      </div>
    </mat-step>
    <!-- Reference -->
    <mat-step label="Verweise">
      <app-reference-table [entry]="references" [editMode]="true" [clickableRefs]="false" [selfId]="id" [selfType]="'text_type'" (entryChange)="handleReferenceChange($event)"></app-reference-table>
      <button mat-raised-button matStepperPrevious>Zurück</button>
    </mat-step>
  </mat-vertical-stepper>

</mat-dialog-content>
<mat-dialog-actions>
  <button mat-dialog-close mat-raised-button>Abbrechen</button>
  <button (click)="createTextType()" [disabled]="firstFormGroup.invalid"
          color="primary" mat-raised-button>
    Speichern
  </button>
</mat-dialog-actions>
